import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";

import styles from "../components/apiStatusDashboardcomponent.module.scss";
import i18next from "i18next";
import _ from "lodash";

import { getStatusApiList } from "../../../services/APIService";
import moment from "moment";

import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";

export default function ApiStatusDashboardcomponent() {
  const [dashboardApiStatus, setDashboardApiStatus] = useState([]);

  const { setApiErrorModalState } = useApiErrorModalContext();

  useEffect(() => {
    getStatusApiList()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDashboardApiStatus(response.apiStatusList);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      className={styles.turngraphTableContainer}
      data-testid="ApiStatusDashboardcomponent"
    >
      <Box className={styles.turnOverheading}>{i18next.t("API Status")}</Box>

      <Box className={styles.apiListWrapper}>
        {dashboardApiStatus.map((item) => {
          return (
            <Box className={styles.apitextlist} key={item.id}>
              <Box className={styles.dot}></Box>
              <Box className={styles.labelapi}>{item.apiName}</Box>

              <Box className={styles.labelapi}>
                {moment(item.apiDateTime).format("DD-MM-YYYY HH:mm:ss A")}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
